export default __webpack_public_path__ + "locales/sq-AL/SendInviteDialog.json?hash=22e2880fc228d3f35b59d63880e1816e";